import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-806b7ae0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm p-4" }, " ゲーム内の時間拡張倍率・早回し倍率を選んで、列車の走行に合わせてボタンを押すと、ゲーム内時間でのだいたいの所要時間が測れます。 ", -1))
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-6 text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "multiplyers" }, " 時間拡張", -1))
const _hoisted_5 = { class: "field col-6 text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fast-forward" }, "早回し", -1))
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-4xl" }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "grid text-center text-4xl px-8 my-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-3xl pb-0" }, "採時区間", -1))
const _hoisted_12 = { class: "col pt-0" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col pt-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pi pi-angle-double-right" })
], -1))
const _hoisted_14 = { class: "col pt-0" }
const _hoisted_15 = { class: "grid my-2" }
const _hoisted_16 = {
  key: 0,
  class: "col-6 text-6xl text-center"
}
const _hoisted_17 = {
  key: 0,
  class: "text-xl"
}
const _hoisted_18 = {
  key: 1,
  class: "text-xl"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(" ") + " ")
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(" ") + " ")
const _hoisted_22 = {
  key: 2,
  class: "text-xl"
}
const _hoisted_23 = {
  key: 3,
  class: "text-xl"
}
const _hoisted_24 = {
  key: 1,
  class: "col-6 text-6xl text-center text-green-800 font-bold"
}
const _hoisted_25 = { class: "col-6 text-6xl text-center" }
const _hoisted_26 = { class: "grid my-2" }
const _hoisted_27 = { class: "grid my-2" }
const _hoisted_28 = { class: "grid" }
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MeasureNecessaryTimeRunningButton = _resolveComponent("MeasureNecessaryTimeRunningButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DiagramTrainTypeNecessaryTimeTable = _resolveComponent("DiagramTrainTypeNecessaryTimeTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.localVisible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localVisible) = $event)),
    onShow: _ctx.reset,
    class: "dialog"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "確定",
        onClick: _ctx.submit
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedMultiplyer,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMultiplyer) = $event)),
              options: _ctx.MULTIPLYERS,
              optionLabel: "name",
              optionValue: "value",
              placeholder: "x3〜x450",
              id: "multiplyers",
              disabled: _ctx.isStarted
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedFastForward,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFastForward) = $event)),
              options: _ctx.FAST_FORWARDS,
              optionLabel: "name",
              optionValue: "value",
              placeholder: "x1〜x3",
              id: "fast-forward",
              disabled: _ctx.isStarted
            }, null, 8, ["modelValue", "options", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              style: _normalizeStyle({ color: _ctx.trainType?.lineColor })
            }, "■", 4),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.trainType?.name || "種別名"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getStation(_ctx.nowStationInfo.sectionFrom)?.name), 1),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getStation(_ctx.nowStationInfo.sectionTo)?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (!_ctx.nowStationInfo.finish)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_ctx.isRunning)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "つぎは"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, "ただいま")),
                _hoisted_19,
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.getStation(_ctx.nowStationInfo.nextStation)?.name), 1),
                _hoisted_21,
                (_ctx.isRunning)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.trainType.stoppingStationList.includes(_ctx.nowStationInfo.nextStation)
                ? "停車"
                : "通過"), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_23, "停車中"))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, " 終了 ")),
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formattedTime), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_MeasureNecessaryTimeRunningButton, {
              onClickRunning: _ctx.onClickRunning,
              onClickPassing: _ctx.onClickPassing,
              isRunning: _ctx.isRunning,
              isPass: 
              !_ctx.trainType.stoppingStationList.includes(
                _ctx.nowStationInfo.nextStation
              )
            ,
              disabled: _ctx.nowStationInfo.finish,
              class: "col mx-1 h-5rem"
            }, null, 8, ["onClickRunning", "onClickPassing", "isRunning", "isPass", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Button, {
              label: "タイマー止",
              class: "p-button-warning col mx-1",
              onClick: _ctx.allStop,
              disabled: !_ctx.isStarted
            }, null, 8, ["onClick", "disabled"]),
            _createVNode(_component_Button, {
              label: "リセット",
              class: "p-button-danger col mx-1",
              onClick: _ctx.reset,
              disabled: !_ctx.isStarted
            }, null, 8, ["onClick", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_DiagramTrainTypeNecessaryTimeTable, {
              modelValue: _ctx.recordedRap.a,
              boundFor: "A",
              editable: false
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_DiagramTrainTypeNecessaryTimeTable, {
              modelValue: _ctx.recordedRap.b,
              boundFor: "B",
              editable: false
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onShow"]))
}